import { z } from 'zod';

export const ProratedStripeUpgradeData = z.object({
  upgradePriceString: z.string(),
  upgradeEquivalentString: z.string().optional(),
  upgradeSavingsPercentage: z.number(),
  upgradeUrl: z.string(),
  proratedFirstPaymentPriceString: z.string().optional(),
});

export type ProratedStripeUpgradeData = z.infer<typeof ProratedStripeUpgradeData>;

export const templateStringPriceToken = '{price}';
